import { PlusIcon } from '../../../../../../common/ui/icons';
import { IFoodCalendarDay, IFoodCalendarMonth } from '../../../../food-interfaces';
import { useFoodStore } from '../../../../data/food-store';

interface IDayView {
    month: IFoodCalendarMonth;
    day: IFoodCalendarDay;
}

const getDayClasses = (day: IFoodCalendarDay, month: IFoodCalendarMonth) => {
    if(day.calories > month.dailyCalories) {
        return 'text-red-700';
    }

    if(day.isTodayDay) {
        return 'text-sky-700 font-bold';
    }

    return 'text-black';
};

const DayView = ({ day, month }: IDayView) => {

    const setDayPopupMetadata = useFoodStore(store => store.setDayPopupMetadata);

    const openDayMetadataPopup = () => {
        setDayPopupMetadata(day.metadata || {
            id: 0,
            day_date: day.dayStartDate.getTime(),
            description: '',
        });
    };

    return (
        <div className={ `food-calendar-day-item bg-slate-50 p-1 ${ day.isTodayDay ? 'text-sky-700' : '' }` }>

            <div className="mb-1 text-right text-xs flex">

                <button
                    className={ `food-calendar-day-metadata mr-auto ${ day.metadata ? '' : 'hidden' }` }
                    title={ day.metadata ? day.metadata.description : `Add Day Metadata` }
                    onClick={ openDayMetadataPopup }
                    type="button">

                    {
                        !day.metadata &&
                        <PlusIcon size={ 9 } color="#000" />
                    }

                    {
                        day.metadata &&
                        <span style={{
                            textShadow: '0px 0 1px #533708'
                        }}>💡</span>
                    }
                </button>

                <span className="ml-auto">{ day.dayName }</span>
            </div>

            <div className={ `text-center text-sm ${ getDayClasses(day, month) }` }>
                { day.calories > 0 && Math.round(day.calories).toLocaleString() }
            </div>
        </div>

    )
};

export default DayView;